import React from "react";
import ItemCard from "./ItemCard";
import Icon from "@material-ui/core/Icon";
import useList from "customHooks/useList";
import { calculateAge } from "functions/util";
import _ from "lodash";
import { IFieldProps } from ".";

const FieldAge = (props: IFieldProps) => {
    const { fieldData, fieldName, returnType } = props;
    const [listData] = useList();
    const { t } = listData.tempInfo;
    const { cardFields } = listData.definitionInfo.elasticDefData?.data || {};

    const dateOfBirth = _.get(fieldData, "dateOfBirth");
    const age = dateOfBirth ? calculateAge(String(dateOfBirth)) : "-";

    switch (returnType) {
        case "card":
            return (
                <ItemCard
                    label={
                        cardFields?.[fieldName]?.cardIcon ? (
                            <Icon color="action" fontSize="small">
                                {cardFields[fieldName].cardIcon}
                            </Icon>
                        ) : (
                            `${t(fieldName)}: `
                        )
                    }
                    removeColonAfterLabel={true}
                >
                    {age}
                </ItemCard>
            );
        case "table":
            return <>{age}</>;
    }
};

export default FieldAge;
